// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"6ea7ef8d","239":"5a5edbbf","406":"7bb31586","872":"f5ebd94b"}[chunkId] + ".chunk.css";
};